/* Wandry newsletter fixed discounts; one 4,000 JPY discount per order. */
(function () {
  'use strict';
  if (window.WD_COUPON) return;
  var key = 'wandry-newsletter-offer-v1';
  var codes = ['WANDRY4000'];
  var retiredCodes = ['WANDRY15', 'WANDRY1000', 'WANDRY2000', 'WANDRY3000'];
  function isEligible() { try { eligible = localStorage.getItem(key) === 'yes'; } catch (_) {} return !!(eligible || (window.EC_SPECIAL_OFFER && EC_SPECIAL_OFFER.current())); }
  function offerAmount() { return window.EC_OFFER_AMOUNT ? EC_OFFER_AMOUNT() : 4000; }
  function owns(code) { return codes.concat(retiredCodes).concat(['W-SUMMER-057BCB58']).indexOf(String(code).toUpperCase()) >= 0; }
  var eligible = false;
  try { eligible = localStorage.getItem(key) === 'yes'; } catch (_) {}
  var pending;
  var applied = isEligible();
  var verifiedItems = false;
  function markApplied(value, hasItems) { applied = value; verifiedItems = !!hasItems; document.dispatchEvent(new CustomEvent("wandry:newsletter-eligible")); }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function sectionRequest() {
    var names = [];
    ['cart-drawer', 'cart-items'].forEach(function(selector) {
      var element = document.querySelector(selector);
      if (element && element.getSectionsToRender) element.getSectionsToRender().forEach(function(section) {
        var name = section.section || section.id;
        if (names.indexOf(name) < 0) names.push(name);
      });
    });
    return names.slice(0, 5);
  }
  function renderCart(cart) {
    if (!cart.sections) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.renderContents && cart.sections['cart-drawer']) {
      drawer.renderContents(cart, true);
      // Section HTML changes do not update the enclosing custom element.
      drawer.classList.toggle('is-empty', cart.item_count === 0);
    }
    var items = document.querySelector('cart-items');
    if (items && items.getSectionsToRender) items.getSectionsToRender().forEach(function(section) {
      var html = cart.sections[section.section || section.id], wrapper = document.getElementById(section.id);
      if (!html || !wrapper) return;
      var target = wrapper.querySelector(section.selector) || wrapper;
      target.innerHTML = items.getSectionInnerHTML(html, section.selector);
    });
  }
  async function apply() {
    if (!isEligible()) return;
    var special = window.EC_SPECIAL_OFFER && EC_SPECIAL_OFFER.current();
    codes[0] = special ? special.code : 'WANDRY4000';
    if (pending) return pending;
    pending = (async function () {
      var response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes[0], sections: sectionRequest(), sections_url: location.pathname })
      });
      if (!response.ok) throw Error('Offer could not be applied');
      var updated = await response.json();
      var items = updated.items || [];
      if (items.length) {
        var target = items.filter(function(item) { return Number(item.product_id) === 8791641129095; });
        var applicable = (updated.discount_codes || []).some(function(entry) { return entry.applicable && String(entry.code).toUpperCase() === codes[0]; });
        var subtotal = items.reduce(function(total,item) { return total + item.original_line_price; }, 0);
        var targetSubtotal = target.reduce(function(total,item) { return total + item.original_line_price; }, 0);
        if (!target.length || !applicable || targetSubtotal < (offerAmount() * 100)) throw Error('Offer is not applicable to this cart');
        if (subtotal - updated.total_price !== (offerAmount() * 100) || updated.total_discount !== (offerAmount() * 100)) throw Error('Order discount could not be verified');
        if ((updated.discount_codes || []).some(function(entry) { return entry.applicable && String(entry.code).toUpperCase() !== codes[0]; })) throw Error('Other discounts cannot combine with this offer');
      }
      markApplied(true, updated.items.some(function(item) { return Number(item.product_id) === 8791641129095; }));
      renderCart(updated);
      return updated;
    })();
    try { return await pending; } catch (error) { markApplied(false); throw error; } finally { pending = null; }
  }
  function remember() {
    eligible = true; applied = true; verifiedItems = false;
    try { localStorage.setItem(key, 'yes'); } catch (_) {}
    document.dispatchEvent(new CustomEvent('wandry:newsletter-eligible'));
  }
  window.WD_COUPON = { amount: offerAmount, apply: apply, remember: remember, showError: showError, isEligible: isEligible, isApplied: function() { return applied; }, hasVerifiedItems: function() { return verifiedItems; } };
  function showError(form) {
    var target = form || document.querySelector('cart-drawer');
    if (!target) return;
    var message = target.querySelector('.wd-offer-error');
    if (!message) {
      message = document.createElement('p');
      message.className = 'wd-offer-error'; message.setAttribute('role', 'alert');
      target.appendChild(message);
    }
    message.textContent = '登録特典を適用できませんでした。利用済み・ほかの割引との併用の場合は通常の購入手続きへ進めます。';
    if (target.querySelector('.wd-offer-skip')) return;
    var skip = document.createElement('button');
    skip.type = 'button'; skip.className = 'button wd-offer-skip';
    skip.textContent = 'この特典を使わず購入手続きへ';
    target.appendChild(skip);
    skip.addEventListener('click', async function () {
      skip.disabled = true;
      try {
        var response = await fetch(root + 'cart.js', { cache: 'no-store' });
        if (!response.ok) throw Error('Cart could not be loaded');
        var cart = await response.json();
        var keep = (cart.discount_codes || []).map(function (entry) { return entry.code; }).filter(function (code) { return !owns(code); });
        response = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: keep.join(',') }) });
        if (!response.ok) throw Error('Offer could not be removed');
        var removed = await response.json();
        if ((removed.discount_codes || []).some(function(entry) { return entry.applicable && owns(entry.code); })) throw Error('Offer remains applied');
        eligible = false; if (window.EC_SPECIAL_OFFER) EC_SPECIAL_OFFER.clear(); markApplied(false);
        try { localStorage.removeItem(key); } catch (_) {}
        document.dispatchEvent(new CustomEvent('wandry:newsletter-eligible'));
        try { if (window.EC_MEASURE) window.EC_MEASURE.event('checkout_redirect'); } catch (_) {} window.location.href = root + 'checkout';
      } catch (_) { skip.disabled = false; message.textContent = '購入手続きを読み込めませんでした。もう一度お試しください。'; }
    });
  }
  // Cover both the cart page and drawer checkout forms. The PDP awaits apply itself.
  document.addEventListener('submit', function (event) {
    var form = event.target, button = event.submitter;
    if (!isEligible() || !button || button.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    button.disabled = true;
    apply().then(function () {
      // Applying the discount re-renders cart sections and replaces this form.
      // The verified cart is ready; navigate without submitting a detached form.
      try { if (window.EC_MEASURE) window.EC_MEASURE.event('checkout_redirect'); } catch (_) {} window.location.href = root + 'checkout';
    }).catch(function () { button.disabled = false; showError(form); });
  }, true);
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!isEligible() || !link || new URL(link.href).pathname !== '/checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    apply().then(function () { window.location.href = link.href; }).catch(function () { showError(); });
  }, true);
  // Verify the email offer immediately; checkout repeats the verification.
  if (window.EC_SPECIAL_OFFER && EC_SPECIAL_OFFER.current()) {
    var initOffer = function () { apply().catch(function () {}); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOffer, {once:true}); else initOffer();
  }
  // No background polling.
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) { applied = isEligible(); verifiedItems = false; document.dispatchEvent(new CustomEvent('wandry:newsletter-eligible')); }
  });
})();

(function () {
  'use strict';
  function modal(success, open) {
    var prefix = success ? '.success' : '.sign-up';
    var panel = document.querySelector(prefix + '-popup-modal');
    var overlay = document.querySelector(prefix + '-popup-overlay');
    if (!panel || !overlay) return;
    panel.classList.toggle('popup-modal--active', open);
    overlay.classList.toggle('popup-overlay--active', open);
    var launcher = document.getElementById('wd-offer-launcher');
    if (launcher) launcher.setAttribute('aria-expanded', String(open));
    if (open) {
      var focus = panel.querySelector(success ? '.popup-modal__copy-btn' : 'input[type="email"]');
      if (focus) focus.focus({ preventScroll: true });
    }
  }
  function open() {
    var button = document.querySelector('.success-popup-modal .popup-modal__copy-btn');
    if (button) { delete button.dataset.emptyCart; delete button.dataset.ready; button.textContent = 'お買い物を続ける'; }
    modal(false, false); modal(true, false);
    var eligible = !!(window.WD_COUPON && WD_COUPON.isEligible());
    modal(eligible, true);
    if (eligible) redeem();
  }
  async function redeem() {
    var panel = document.querySelector('.success-popup-modal');
    var button = panel && panel.querySelector('.popup-modal__copy-btn');
    var message = panel && panel.querySelector('.popup-modal__success-msg');
    if (!button || button.disabled) return;
    button.disabled = true; button.textContent = '特典を確認しています…';
    try {
      var cart = await WD_COUPON.apply();
      if (cart && cart.item_count) {
        // Thank you画面で「適用済み」を見せ、ボタンで購入手続きへ（2026-09-07 クイズ型ポップアップ）
        if (message) { message.textContent = 'この注文に4,000円OFFを適用しました。'; message.style.display = 'block'; }
        button.textContent = '4,000円OFFで購入手続きへ';
        button.dataset.ready = 'checkout';
        return;
      }
      if (message) { message.textContent = '商品をカートに追加すると、4,000円OFFが適用されます。'; message.style.display = 'block'; }
      button.textContent = 'お買い物を続ける';
      button.dataset.emptyCart = 'true';
    } catch (_) {
      if (message) { message.textContent = '特典を確認できませんでした。もう一度お試しください。'; message.style.display = 'block'; }
      button.textContent = 'もう一度確認する';
    } finally { button.disabled = false; }
  }
  function init() {
    var launcher = document.getElementById('wd-offer-launcher');
    if (!launcher) return;
    /* 2026-09-07 本人指定: メール登録済み（特典資格あり）の人には右下の再表示ボタンを出さない */
    function syncLauncher() { launcher.hidden = !!(window.WD_COUPON && WD_COUPON.isEligible()); }
    syncLauncher();
    launcher.addEventListener('click', open);
    document.querySelectorAll('.promp-popup__close-btn').forEach(function(button) {
      button.addEventListener('click', function() { modal(false, false); launcher.focus({preventScroll:true}); });
    });
    var success = document.querySelector('.success-popup-modal');
    if (success) {
      success.querySelectorAll('.popup-modal__close,.popup-modal__dismiss-btn').forEach(function(button) {
        button.addEventListener('click', function() { modal(true, false); launcher.focus({preventScroll:true}); });
      });
      success.querySelector('.popup-modal__copy-btn').addEventListener('click', function(event) {
        var target = event.currentTarget;
        if (target.dataset.emptyCart === 'true') { modal(true, false); document.querySelector('#hlpOfferRow')?.scrollIntoView({block:'center'}); }
        else if (target.dataset.ready === 'checkout') { target.disabled = true; target.textContent = '購入手続きへ進んでいます…'; try { if (window.EC_MEASURE) window.EC_MEASURE.event('checkout_redirect'); } catch (_) {} window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout'; }
        else redeem();
      });
    }
    document.querySelector('.success-popup-overlay')?.addEventListener('click', function() { modal(true, false); });
    document.addEventListener('keydown', function(event) { if (event.key === 'Escape') { modal(false, false); modal(true, false); } });
    window.WD_REGISTRATION_SUCCESS = function() {
      try { if (window.EC_MEASURE) window.EC_MEASURE.event('newsletter_confirmed'); } catch (_) {} 
      WD_COUPON.remember(); syncLauncher();
      modal(false, false); modal(true, true);
      redeem();
    };
    if (window.WD_NATIVE_SIGNUP_SUCCESS) { window.WD_REGISTRATION_SUCCESS(); return; }
    // One automatic presentation per tab visit; persistent registration still suppresses it.
    // Ignore the previous theme's long-lived dismissal record.
    var visitKey = 'wandry-newsletter-shown-session-v2';
    var seen = false;
    try { seen = sessionStorage.getItem(visitKey) === 'yes'; } catch (_) {}
    var failedSignup = !!document.querySelector('.sign-up-popup-modal [aria-invalid="true"]');
    if (!WD_COUPON.isEligible() && (!seen || failedSignup)) {
      try { sessionStorage.setItem(visitKey, 'yes'); } catch (_) {}
      modal(false, true);
    }
    document.addEventListener('wandry:newsletter-eligible', function() {
      syncLauncher();
      if (WD_COUPON.isEligible()) modal(false, false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
